
import Provider from '../model/Provider.js';
import Config   from '../model/Config';
import { providerChk } from './provider.id.check.js';

export function apiPost(url,params){
    return new Promise((resolve, reject) => {
        $.ajax({
            type: "POST",
            url: url,
            headers: { 
                Accept : "application/json; charset=utf-8",
                "Content-Type": "application/json; charset=utf-8"
            },
            dataType: "text",
            data: params,
            beforeSend: function (xhr) {   
                // xhr.setRequestHeader("Authorization", sessionStorage.getItem("Authorization"));
            },
            success: function (res) {
                if(typeof res  == "string" && res.replace(/\s/gi, "") == ""){
                    console.error("No data to return.");
                    reject(res);
                    return;
                }
                const provider = JSON.parse(res);
                if(provider !== undefined){
                    
                    if(provider.resultCode != 200 && provider.resultCode != 0){
                        reject(res);
                        return;
                    }

                    Provider.token = provider.token;
                    if(provider.txId !== undefined){
                        Provider.txId  = provider.txId;
                    }
                    if(provider.cxId !== undefined){
                        Provider.cxId  = provider.cxId;
                    }
                    if(provider.reqTxId !== undefined){
                        Provider.reqTxId  = provider.reqTxId;
                    }

                    if(provider.data !== undefined) {

                        //naver
                        if(provider.data.naverAppSchemeUrl !== undefined){
                            Provider.naverAppSchemeUrl = provider.data.naverAppSchemeUrl
                        }
                        //pass
                        if(provider.data.reqTxId !== undefined){
                            Provider.reqTxId = provider.data.reqTxId;
                        }
                        //pass
                        if(provider.data.telcoTxId !== undefined){
                            Provider.telcoTxid = provider.data.telcoTxId;
                        }
                        //pass
                        if(provider.data.extProperties !== undefined){
                            Provider.telcoTxid = provider.data.extProperties.telcoTxid;
                            //samsung
                            if(provider.data.extProperties[0] != null || provider.data.extProperties[0] !== undefined){
                                Provider.deeplinkUri = provider.data.extProperties[0].deeplinkUri;
                            }
                        }
                        //건강보험공단, 특허청 entry 구조 예외처리
                        if(provider.data.entry !== undefined){
                            if(provider.data.entry.length > 0){
                                if(provider.data.entry[0].key === "extProperties"){
                                    if(providerChk.isPass(Provider.providerId)){
                                        Provider.telcoTxid = provider.data.entry[0].value.replace("{telcoTxid=","").replace("}","")
                                    }
                                    if(providerChk.isSamsung(Provider.providerId)){
                                        Provider.deeplinkUri = provider.data.entry[0].value.replace("{deeplinkUri=","").replace("}","")
                                    }
                                }
                            }
                        }

                        // Deep Link Uri 규격
                        if( !!provider.data.deeplinkUrl ){
                            Provider.deeplinkUri = provider.data.deeplinkUrl
                        }
                        if( !!provider.data.appScheme ){
                            Provider.deeplinkUrl = provider.data.appScheme
                        }
                    }
                }
                if(Config.system.console_debug){
                    console.log("Response: "+res, " | Provider Info: "+JSON.stringify(Provider));
                }
                if(Config.system.alert_debug){
                    alert(JSON.stringify(res));
                }
                resolve(res);
            },
            error: function (xhr, status, error) {
                var errMsg = {
                    xhr: xhr,
                    status: status,
                    error: error
                }
                if(Config.system.console_debug){
                    console.log(errMsg);
                }
                if(Config.system.alert_debug){
                    alert(JSON.stringify(errMsg));
                }
                reject(errMsg)
            },
            complete : function(xhr) {
            }
        });
    });
}


export function apiGet(url){
    return new Promise((resolve, reject) => {
        $.ajax({
            type: "GET",
            url: url,
            headers: { 
                Accept : "application/json; charset=utf-8",
                "Content-Type": "application/json; charset=utf-8"
            },
            dataType: "json",
            success: function (res) {
                if(Config.system.console_debug){
                    console.log(res);
                }
                if(Config.system.alert_debug){
                    alert(JSON.stringify(res));
                }
                if(typeof res  == "string" && res.replace(/\s/gi, "") == ""){
                    console.error("No data to return.");
                    reject(res);
                    return;
                }
                if(res == ""){
                    reject(res);
                    return;
                }
                
                resolve(res);
            },
            error: function (xhr, status, error) {
                var errMsg = {
                    xhr: xhr,
                    status: status,
                    error: error
                }
                if(Config.system.console_debug){
                    console.log(errMsg);
                }
                if(Config.system.alert_debug){
                    alert(JSON.stringify(errMsg));
                }
                reject(errMsg);
            }
        });
    })
}

export function textFileGet(url){
    return new Promise((resolve, reject) => {
        $.ajax({
            type: "GET",
            url: url,
            headers: { 
                Accept : "application/json; charset=utf-8",
                "Content-Type": "application/json; charset=utf-8"
            },
            dataType: "text",
            success: function (res) {
                if(Config.system.console_debug){
                    console.log(res);
                }
                if(Config.system.alert_debug){
                    alert(JSON.stringify(res));
                }
                resolve(res);
            },
            error: function (xhr, status, error) {
                var errMsg = {
                    xhr: xhr,
                    status: status,
                    error: error
                }
                if(Config.system.console_debug){
                    console.log(errMsg);
                }
                if(Config.system.alert_debug){
                    alert(JSON.stringify(errMsg));
                }
                let content = "";
                if(xhr.status == "404"){
                    content = url+" 파일이 존재하지 않습니다." 
                }else if(xhr.status == "0"){
                    content = "네트워크 연결을 확인해 주세요."
                }
                alert(content)
                // viewEvent.view_msg();
                reject(errMsg);
            }
        });
    });
}

export function fileGet(url){
    return new Promise((resolve, reject) => {
        $.ajax({
            type: "GET",
            url: url,
            headers: { 
                Accept : "application/json; charset=utf-8",
                "Content-Type": "application/json; charset=utf-8"
            },
            dataType: "json",
            success: function (res) {
                if(Config.system.console_debug){
                    console.log(res);
                }
                if(Config.system.alert_debug){
                    alert(JSON.stringify(res));
                }
                resolve(res);
            },
            error: function (xhr, status, error) {
                var errMsg = {
                    xhr: xhr,
                    status: status,
                    error: error
                }
                if(Config.system.console_debug){
                    console.log(errMsg);
                }
                if(Config.system.alert_debug){
                    alert(JSON.stringify(errMsg));
                }
                let content = "";
                if(xhr.status == "404"){
                    content = url+" 파일이 존재하지 않습니다."
                }else if(xhr.status == "0"){
                    content = "네트워크 연결을 확인해 주세요."
                }else{
                    content = errMsg.error
                }
                alert(content)
                // viewEvent.view_msg();
                reject(errMsg);
            }
        });
    });
}

export function apiPost_demo(url,params){
    return new Promise((resolve, reject) => {
        $.ajax({
            type: "POST",
            url: url,
            contentType: "application/x-www-form-urlencoded; charset=utf-8",
            dataType: "text",
            data: params,
            beforeSend: function (xhr) {   
                // xhr.setRequestHeader("Authorization", sessionStorage.getItem("Authorization"));
            },
            success: function (res) {
                if(Config.system.console_debug){
                    console.log(res);
                }
                if(Config.system.alert_debug){
                    alert(JSON.stringify(res));
                }
                resolve(res);
            },
            error: function (xhr, status, error) {
                var errMsg = {
                    xhr: xhr,
                    status: status,
                    error: error
                }
                if(Config.system.console_debug){
                    console.log(errMsg);
                }
                if(Config.system.alert_debug){
                    alert(JSON.stringify(errMsg));
                }
                reject(errMsg)
            },
            complete : function(xhr) {
            }
        });
    });
}